<template>
  <Head>
    <Title>Focení novorozenců - Ludmila Zacharová</Title>
  </Head>
  <siteblocks-navmenu />
  <v-container>
    <v-sheet class="mx-4">
      <h1>Focení novorozenců</h1>
      <div class="mb-5">
        <br>
        
        První dny vašeho děťátka – zachycené navždy.
        <br><br>
        Ty nejjemnější okamžiky si zaslouží být uchovány. Jsem tu, abych vám pomohla uchovat ty nejcennější vzpomínky. Vedu vás každým krokem, aby focení bylo přirozené a příjemné, a postarám se o každý detail s citem a láskou.
        Vaše rodinná láska zachycená v něžných fotografiích – poklad, ke kterému se budete stále vracet.
        <br><br>
        Focení probíhá v mém útulném domácím ateliéru nebo v pohodlí vašeho domova.
        Rezervujte si svůj termín včas – první dny miminka jsou jedinečné. 
        <br><br>
        Chcete někomu udělat radost? Toto focení si můžete koupit jako dárek. Mám pro vás připravené krásné dárkové poukazy.
        <br><br>
        Rezervace termínu nebo objednávka poukazu v soukromých zprávách.
        <br><br>
      </div>
    </v-sheet>
    <v-row v-for="index in 12">
      <v-col cols="12" md="6">
        <v-img :src="'/newborn/' + (index * 2 - 1) + '.jpg'" aspect-ratio="5:4"/>
      </v-col>
      <v-col cols="12" md="6">
        <v-img :src="'/newborn/' + (index * 2) + '.jpg'" aspect-ratio="5:4"/>
      </v-col>
    </v-row>

    <v-row v-for="index in 2">
      <v-col cols="12" md="6">
        <v-img :src="'/newborn/' + (index * 2 + 23) + '.jpg'" aspect-ratio="1:1"/>
      </v-col>
      <v-col cols="12" md="6">
        <v-img :src="'/newborn/' + (index * 2 + 24) + '.jpg'" aspect-ratio="1:1"/>
      </v-col>
    </v-row>

    <v-row v-for="index in 7">
      <v-col cols="12" md="6">
        <v-img :src="'/newborn/' + (index * 2 + 27) + '.jpg'" aspect-ratio="4:3"/>
      </v-col>
      <v-col cols="12" md="6">
        <v-img :src="'/newborn/' + (index * 2 + 28) + '.jpg'" aspect-ratio="4:3"/>
      </v-col>
    </v-row>

  </v-container>
</template>